import { Box, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback } from 'react';

import { TLocalesKeys } from '../../../types';
import { biHelpCenter } from '../../../util/bi';
import { SectionComponentProps } from '../types';

const STATUS_PAGE_URL = 'https://status.wix.com/';

export const StatusPage: FC<SectionComponentProps> = ({ positionIndex }) => {
  const { t } = useTranslation();
  const onClick = useCallback(() => {
    biHelpCenter.logStatusPageInteraction(
      STATUS_PAGE_URL,
      t<TLocalesKeys>('home_status_page_button'),
      positionIndex,
    );
  }, [positionIndex, t]);

  return (
    <Box
      margin="24px -18px 0"
      padding="12px 18px"
      align-items="center"
      backgroundColor="#ECEFF3"
      align="center"
    >
      <Text size="small" weight="normal" secondary>
        {t<TLocalesKeys>('home_status_page_text')}
        &nbsp;
        <TextButton
          size="small"
          as="a"
          href={STATUS_PAGE_URL}
          target="_blank"
          onClick={onClick}
        >
          {t<TLocalesKeys>('home_status_page_button')}
        </TextButton>
        .
      </Text>
    </Box>
  );
};
